import $ from "jquery"
import "./collapse.scss"

/***
Bouton  : .sli-collapse-btn sli-collapse-btn-close | sli-collapse-btn-open / data-target=[pointer vers élément(s)]

Conteneur collapse : .sli-collapse / data-state="open|close"
    inner collapse : .sli-collapse-inner
    
*/

class SliCollapse {

    constructor () {

        this.bp = 1024;
        this.isMob = window.innerWidth < 1024;
        $( window ).on( "resize", () => {
            this.isMob = window.innerWidth < 1024;
        });

        $(document).on( 'click' , '.sli-collapse-btn:has(.icon)' , e => {
            $('.sli-collapse-btn')
            if( $(e.currentTarget).attr( 'data-type' ) === "accordion" && $(e.currentTarget).hasClass('sli-collapse-btn-close') ){                
                this.closeOpened( $(e.currentTarget) )
            }
            this.collapse( $(e.currentTarget) )
        })

        $(document).on( 'click' , '.sli-collapse-btn:has(i)' , e => {
            if( $(e.currentTarget).attr( 'data-type' ) === "accordion" && $(e.currentTarget).hasClass('sli-collapse-btn-close') ){                
                this.closeOpened( $(e.currentTarget) )
            }
            this.collapse( $(e.currentTarget) )
        })
        
    }

    collapse ( btn ) {
        
        let target = this.isMob 
            ? $("#mob-"+btn.attr( 'data-target' ))
            : $("#"+btn.attr( 'data-target' ))

        let inner = $( target ).find('.sli-collapse-inner')
        
        // Il est fermé, alors on l'ouvre
        if( target.attr('data-state') === "close" ){


            
            let theHeight = inner.outerHeight( true )

            target.animate( {
                height: theHeight
            }, 300, function(){
                $(target).css('height' , 'auto')
            })

            target.attr('data-state' , 'open')
            btn.addClass( 'sli-collapse-btn-open' ).removeClass( 'sli-collapse-btn-close' )

        }
        // Sinon:  Il est ouvert, alors on le ferme 
        else{
            target.animate( {
                height: 0
            })
            target.attr('data-state' , 'close')
            btn.addClass( 'sli-collapse-btn-close' ).removeClass( 'sli-collapse-btn-open' )
        }

    }

    closeOpened ( btn ) {

        let wrap = btn.closest( '.sli-collapse-wrap' )

        wrap.find( '.sli-collapse[data-state=open]' ).each( (index, element) => {

            let target = $(element) 
            target.animate({
                height: 0
            })
            target.attr('data-state' , 'close')

            let btn = wrap.find( '.sli-collapse-btn[data-target="'+ target.attr('id') +'"]' )
            btn.addClass( 'sli-collapse-btn-close' ).removeClass( 'sli-collapse-btn-open' )

        })
        //let inner = $( target ).find('.sli-collapse-inner')
    }

}

export {SliCollapse}
